import React, { useState } from "react";
import { FreshWaterGeneratorList } from "./FreshWaterGeneratorList";
import { AirConditioningGeneretorList } from "./AirConditioningGeneretorList";
import { RefrigerationList } from "./RefrigerationList";
import { Other_auxi_plant_list } from "./Other_auxi_plant_list";

function OtherMachinarySubTab({ eng_log_basic_id }) {
  const [activeTab, setActiveTab] = useState("Fresh Water Generator");

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li
            className={activeTab === "Fresh Water Generator" ? "active" : ""}
            onClick={() => handleClick("Fresh Water Generator")}
          >
            Fresh Water Generator
          </li>
          <li
            className={activeTab === "Air Conditioning Generator" ? "active" : ""}
            onClick={() => handleClick("Air Conditioning Generator")}
          >
            Air Conditioning Plant
          </li>

          <li
            className={activeTab === "Refrigeration Plant" ? "active" : ""}
            onClick={() => handleClick("Refrigeration Plant")}
          >
            Refrigeration Plant
          </li>
          <li
            className={activeTab === "Other" ? "active" : ""}
            onClick={() => handleClick("Other")}
          >
            Other
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "Fresh Water Generator" && <FreshWaterGeneratorList id={eng_log_basic_id} />}
        {activeTab == "Air Conditioning Generator" && (
          <AirConditioningGeneretorList id={eng_log_basic_id} />
        )}
        {activeTab == "Refrigeration Plant" && <RefrigerationList id={eng_log_basic_id} />}
        {activeTab == "Other" && <Other_auxi_plant_list id={eng_log_basic_id} />}
      </div>
    </>
  );
}

export default OtherMachinarySubTab;
